// legacy file used by the solar commercial calculato to initliase the map.
var perth = { lat: -31.949772, lng: 115.772961 }
var zoom = 12
/**
 * The CenterControl adds a control to the map that recenters the map on
 * Perth.
 * This constructor takes the control DIV as an argument.
 *
 */

// These functions needs to be exposed to the global window object because webpack seems encapsulates the module in an IIFE when it bundles the file creating it's own scope.
window.CenterControl = CenterControl
window.initAutocomplete = initAutocomplete
window.googleMapButton = googleMapButton
window.FullScreenControl = FullScreenControl;

function CenterControl(controlDiv, map) {
    // Set CSS for the control border.
    var controlUI = document.createElement('div')
    controlUI.style.backgroundColor = '#fff'
    controlUI.style.border = '2px solid #fff'
    controlUI.style.borderRadius = '3px'
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
    controlUI.style.cursor = 'pointer'
    controlUI.style.marginRight = '10px'
    controlUI.style.height = '28px'
    controlUI.style.width = '28px'
    controlUI.style.textAlign = 'center'
    controlUI.title = 'Click to recenter the map'
    controlDiv.appendChild(controlUI)

    // Set CSS for the control interior.
    var controlText = document.createElement('div')
    controlText.style.color = 'rgb(25,25,25)'
    controlText.style.fontFamily = 'Roboto,Arial,sans-serif'
    controlText.style.padding = '2px'

    controlText.innerHTML = '<img src="/images/map-marker-icon.png" width="20" height="20">'
    controlUI.appendChild(controlText)

    // Setup the click event listeners: simply set the map to perth.
    controlUI.addEventListener('click', function () {
        map.setCenter(perth)
        map.setZoom(zoom)
    })
}

function googleMapButton(text, className) {
    'use strict'
    var controlDiv = document.createElement('div')
    controlDiv.className = className
    controlDiv.index = 2
    controlDiv.style.padding = '10px'
    // set CSS for the control border.
    var controlUi = document.createElement('div')
    controlUi.style.backgroundColor = 'rgb(255, 255, 255)'
    controlUi.style.color = '#565656'
    controlUi.style.cursor = 'pointer'
    controlUi.style.textAlign = 'center'
    controlUi.style.boxShadow = 'rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px'
    controlDiv.appendChild(controlUi)
    // set CSS for the control interior.
    var controlText = document.createElement('div')
    controlText.id = 'fs-inner-button'
    controlText.style.fontFamily = 'Roboto,Arial,sans-serif'
    controlText.innerHTML = text
    controlUi.appendChild(controlText)

    return controlDiv
}

function FullScreenControl(map, enterFull, exitFull) {
    'use strict'
    if (enterFull === void 0) {
        enterFull = null
    }
    if (exitFull === void 0) {
        exitFull = null
    }
    if (enterFull == null) {
        enterFull = '<img src="/images/tfullscreenboi.png" width="20" height="20">'
    }
    if (exitFull == null) {
        exitFull = 'Exit full screen'
    }
    var controlDiv = googleMapButton(enterFull, 'fs-inner-div')
    var fullScreen = false
    var interval
    var mapDiv = map.getDiv()
    var divStyle = mapDiv.style
    if (mapDiv.runtimeStyle) {
        divStyle = mapDiv.runtimeStyle
    }
    var originalPos = divStyle.position
    var originalWidth = divStyle.width
    var originalHeight = divStyle.height
    // ie8 hack
    if (originalWidth === '') {
        originalWidth = mapDiv.style.width
    }
    if (originalHeight === '') {
        originalHeight = mapDiv.style.height
    }
    var originalTop = divStyle.top
    var originalLeft = divStyle.left
    var originalZIndex = divStyle.zIndex
    var bodyStyle = document.body.style
    if (document.body.runtimeStyle) {
        bodyStyle = document.body.runtimeStyle
    }
    var originalOverflow = bodyStyle.overflow
    controlDiv.goFullScreen = function () {
        var center = map.getCenter()
        mapDiv.style.position = 'fixed'
        mapDiv.style.width = '100%'
        mapDiv.style.height = '100%'
        mapDiv.style.top = '0'
        mapDiv.style.left = '0'
        mapDiv.style.zIndex = '100'
        document.body.style.overflow = 'hidden'

        var button = document.getElementById('fs-inner-button')
        button.innerHTML = exitFull
        button.style.width = '100px'

        fullScreen = true
        google.maps.event.trigger(map, 'resize')
        map.setCenter(center)
        // this works around street view causing the map to disappear, which is caused by Google Maps setting the
        // css position back to relative. There is no event triggered when Street View is shown hence the use of setInterval
        interval = setInterval(function () {
            if (mapDiv.style.position !== 'fixed') {
                mapDiv.style.position = 'fixed'
                google.maps.event.trigger(map, 'resize')
            }
        }, 100)
    }
    controlDiv.exitFullScreen = function () {
        var center = map.getCenter()
        if (originalPos === '') {
            mapDiv.style.position = 'relative'
        } else {
            mapDiv.style.position = originalPos
        }
        mapDiv.style.width = originalWidth
        mapDiv.style.height = originalHeight
        mapDiv.style.top = originalTop
        mapDiv.style.left = originalLeft
        mapDiv.style.zIndex = originalZIndex
        document.body.style.overflow = originalOverflow

        var button = document.getElementById('fs-inner-button')
        button.innerHTML = enterFull
        button.style.width = '28px'

        fullScreen = false
        google.maps.event.trigger(map, 'resize')
        map.setCenter(center)
        clearInterval(interval)
    }
    // setup the click event listener
    google.maps.event.addDomListener(controlDiv, 'click', function () {
        if (!fullScreen) {
            controlDiv.goFullScreen()
        } else {
            controlDiv.exitFullScreen()
        }
    })
    return controlDiv
}

function initAutocomplete() {
    var mapElement = document.getElementById('map')

    if (mapElement) {
        var map = new google.maps.Map(mapElement, {
            center: perth,
            zoom: zoom,
            streetViewControl: false,
            mapTypeControl: false,
            scaleControl: false,
            panControl: false,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.DEFAULT,
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            mapTypeId: 'hybrid'
        })

        // Create the search box and link it to the UI element.
        var input = document.getElementById('pac-input')
        var searchButton = input.querySelector('#search-submit-button')
        searchButton.addEventListener('click', function () {
            google.maps.event.trigger(map, 'bounds_changed')
            placeChanged()
        })

        var inputField = input.querySelector('#search-form-submit')
        var searchBox = new google.maps.places.SearchBox(inputField)
        map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(input)

        //Heading to input box
        var heading = document.getElementById('heading')
        map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(heading)

        // Bias the SearchBox results towards current map's viewport.
        map.addListener('bounds_changed', function () {
            searchBox.setBounds(map.getBounds())
        })

        // Create the DIV to hold the control and call the CenterControl()
        // constructor passing in this DIV.
        var centerControlDiv = document.createElement('div')
        var centerControl = new CenterControl(centerControlDiv, map)

        centerControlDiv.index = 1
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centerControlDiv)

        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
            FullScreenControl(map, '<img src="/images/tfullscreenboi.png" width="20" height="20">', 'Exit Full Screen')
        )

        var markers = []
        // Listen for the event fired when the user selects a prediction and retrieve
        // more details for that place.
        searchBox.addListener('places_changed', function () {
            placeChanged()
        })

        function placeChanged() {
            // show calculator if hidden
            angular.element(document.getElementById('solar_com_calculator_container')).scope().showCalculator()
            //
            var places = searchBox.getPlaces()

            if (places.length == 0) {
                return
            }

            // Clear out the old markers.
            markers.forEach(function (marker) {
                marker.setMap(null)
            })
            markers = []

            // For each place, get the icon, name and location.
            var bounds = new google.maps.LatLngBounds()
            places.forEach(function (place) {
                if (!place.geometry) {
                    //console.log("Returned place contains no geometry");
                    return
                }
                var icon = {
                    url: place.icon,
                    size: new google.maps.Size(71, 71),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(25, 25)
                }

                // Create a marker for each place.
                markers.push(
                    new google.maps.Marker({
                        map: map,
                        icon: icon,
                        title: place.name,
                        position: place.geometry.location
                    })
                )

                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport)
                } else {
                    bounds.extend(place.geometry.location)
                }

                var address = ''
                if (place.address_components) {
                    address = [
                        (place.address_components[0] && place.address_components[0].short_name) || '',
                        (place.address_components[1] && place.address_components[1].short_name) || '',
                        (place.address_components[2] && place.address_components[2].short_name) || ''
                    ].join(' ')

                    var subpremise = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'subpremise') {
                            return o
                        }
                    })[0]

                    var postalCode = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'postal_code') {
                            return o
                        }
                    })[0]

                    var street_number = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'street_number') {
                            return o
                        }
                    })[0]

                    var route = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'route') {
                            return o
                        }
                    })[0]

                    var locality = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'locality') {
                            return o
                        }
                    })[0]

                    var administrative_area_level_1 = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'administrative_area_level_1') {
                            return o
                        }
                    })[0]

                    var country = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'country') {
                            return o
                        }
                    })[0]

                    var street = subpremise ? subpremise.short_name + '/' : ''
                    street += street_number ? street_number.short_name : ''
                    street += ' '
                    street += route ? route.short_name : ''

                    var completeAddress = {
                        street: street,
                        city: locality ? locality.short_name : '',
                        state: administrative_area_level_1 ? administrative_area_level_1.short_name : '',
                        country: country ? country.short_name : '',
                        postalCode: postalCode ? postalCode.short_name : ''
                    }

                    var inputAddress = $('#SolarBattery-connectionAddress')
                    $('#SolarBattery-connectionAddress').val(completeAddress.street)
                    inputAddress.trigger('input')
                    inputAddress.trigger('change')

                    var inputSuburb = $('#SolarBattery-connectionAddressSuburb')
                    $('#SolarBattery-connectionAddressSuburb').val(completeAddress.city)
                    inputSuburb.trigger('input')
                    inputSuburb.trigger('change')

                    var inputPostcode = $('#SolarBattery-connectionAddressPostcode')
                    $('#SolarBattery-connectionAddressPostcode').val(completeAddress.postalCode)
                    inputPostcode.trigger('input')
                    inputPostcode.trigger('change')
                }
            })
            map.fitBounds(bounds)
        }
    }
}